import createExchangeQuotesAtom from './exchange-quotes.js';
import createExchangeStatusAtom from './exchange-status.js';
import createExchangeRemoteConfigAtom from './exchange-remote-config.js';
import createExchangeAvailabilityAtom from './exchange-availability.js';
import createExchangeableAssetsAtom from './exchangeable-assets.js';
export const exchangeStatusAtomDefinition = {
    id: 'exchangeStatusAtom',
    type: 'atom',
    factory: createExchangeStatusAtom,
    dependencies: [],
    public: true,
};
export const exchangeQuotesAtomDefinition = {
    id: 'exchangeQuotesAtom',
    type: 'atom',
    factory: createExchangeQuotesAtom,
    dependencies: [],
    public: true,
};
export const exchangeRemoteConfigAtomDefinition = {
    id: 'exchangeRemoteConfigAtom',
    type: 'atom',
    factory: createExchangeRemoteConfigAtom,
    dependencies: ['remoteConfig'],
    public: true,
};
export const exchangeAvailabilityAtomDefinition = {
    id: 'exchangeAvailabilityAtom',
    type: 'atom',
    factory: createExchangeAvailabilityAtom,
    dependencies: [],
    public: false,
};
export const exchangeableAssetsAtomDefinition = {
    id: 'exchangeableAssetsAtom',
    type: 'atom',
    factory: createExchangeableAssetsAtom,
    dependencies: [],
    public: true,
};
